module.exports = __webpack_public_path__ + "static/media/phone_in_talk-24px.77e3ccda.svg";